import { render, staticRenderFns } from "./ShopeeInv.vue?vue&type=template&id=45f694b7&"
import script from "./ShopeeInv.vue?vue&type=script&lang=js&"
export * from "./ShopeeInv.vue?vue&type=script&lang=js&"
import style0 from "./ShopeeInv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports